module.exports = "<p>\n  summary-report works!\n</p>\n"